// extracted by mini-css-extract-plugin
module.exports = {"emptyMessage":"EmptyMessage_emptyMessage__2xTl9","spin360":"EmptyMessage_spin360__kZCf3"};